import { FloraIcon } from '@practium/ui';
import styles from './FloraAICard.module.css';

export const FloraAICard = () => {
	return (
		<div className={styles.card}>
			<div className={styles.iconContainer}>
				<FloraIcon className={styles.floraIcon} />
			</div>
			<h3 className={styles.title}>Flora AI</h3>
		</div>
	);
};
